import { NavLink } from "react-router-dom";
import { Ads } from "../../icons/index.js";
import "./WebManagementNavBarNew.scss";

const WebManagementNavbarNew = () => {
  return (
    <nav className="webManagementNavBarNew">
      <div className="webManagementNavBarNew__menu">
        <ul className="webManagementNavBarNew__menu__list">
          <NavLink to="/web">
            <li className="webManagementNavBarNew__menu__list__item">
              <div>
                <Ads className="navigate__link--icon" />
                <span>Home</span>
              </div>
            </li>
          </NavLink>
          <NavLink to="/catalogosWeb">
            <li className="webManagementNavBarNew__menu__list__item">
              <div>
                <Ads className="navigate__link--icon" />
                <span>Catálogos</span>
              </div>
            </li>
          </NavLink>
          <NavLink to="/serviciosWeb">
            <li className="webManagementNavBarNew__menu__list__item">
              <div>
                <Ads className="navigate__link--icon" />
                <span>Servicios</span>
              </div>
            </li>
          </NavLink>
          <NavLink to="/contactoWeb">
            <li className="webManagementNavBarNew__menu__list__item">
              <div>
                <Ads className="navigate__link--icon" />
                <span>Contacto</span>
              </div>
            </li>
          </NavLink>
          <NavLink to="/blogWeb">
            <li className="webManagementNavBarNew__menu__list__item">
              <div>
                <Ads className="navigate__link--icon" />
                <span>Blog</span>
              </div>
            </li>
          </NavLink>
          <NavLink to="/oficinasWeb">
            <li className="webManagementNavBarNew__menu__list__item">
              <div>
                <Ads className="navigate__link--icon" />
                <span>Oficinas</span>
              </div>
            </li>
          </NavLink>
          <NavLink to="/faqsListadosWeb">
            <li className="webManagementNavBarNew__menu__list__item">
              <div>
                <Ads className="navigate__link--icon" />
                <span>FAQs listados</span>
              </div>
            </li>
          </NavLink>
          <NavLink to="/zonesManagement">
            <li className="webManagementNavbar__menu__list__item">
              <div>
                <Ads className="navigate__link--icon" />
                <span>Zonas</span>
              </div>
            </li>
          </NavLink>
        </ul>
      </div>
    </nav>
  );
};

export default WebManagementNavbarNew;
